import Component from "@glimmer/component";

import { tracked } from "@glimmer/tracking";
import { action } from "@ember/object";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { object } from "prop-types";

import { service } from "@ember/service";
import { stringable } from "glesys-controlpanel/utils/prop-types";

@forbidExtraArgs
export default class ThreeWayToggle extends Component {
  @service intl;

  @arg(object) leftItem = {
    label: {
      active: this.intl.t("component.three-way-toggle.default.left.active"),
      passive: this.intl.t("component.three-way-toggle.default.left.passive"),
    },
    value: "off",
    action: () => {},
  };

  @arg(object) centerItem = {
    label: {
      active: this.intl.t("component.three-way-toggle.default.center.active"),
      passive: this.intl.t("component.three-way-toggle.default.center.passive"),
    },
    value: "center",
    action: () => {},
  };

  @arg(object) rightItem = {
    label: {
      active: this.intl.t("component.three-way-toggle.default.right.active"),
      passive: this.intl.t("component.three-way-toggle.default.right.passive"),
    },
    value: "on",
    action: () => {},
  };

  @arg(object) selectedItem = this.centerItem;

  @arg(stringable) ariaLabel = this.intl.t("component.three-way-toggle.default.aria-label");

  @tracked currentItem = this.selectedItem;

  get ariaChecked() {
    if (this.selectedItem.value == this.leftItem.value) {
      return "false";
    }

    if (this.selectedItem.value == this.rightItem.value) {
      return "true";
    }

    return "mixed";
  }

  @action
  setCurrent(item) {
    if (this.currentItem != item) {
      this.currentItem = item;
      this.currentItem.action();
    }
  }

  @action
  setValue() {
    if (this.currentItem.value == this.leftItem.value) {
      this.currentItem = this.rightItem;
    } else if (this.currentItem.value == this.rightItem.value) {
      this.currentItem = this.leftItem;
    } else {
      this.currentItem = this.rightItem;
    }
    this.currentItem.action();
  }
}
